import React, { useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import CloseIcon from "../../../../../assets/icons/closeIcon.svg";
import { SearchInputComponent } from "../../../../../common/components";
import "./company-dashboard-initiative-drawer-side-bar.scss";

const CompanyDashboardInitiativeDrawerSideBarDepartmentPopup: any = (
  props: any,
) => {
  const {
    isShowEditDepartment,
    onSearch,
    departments,
    selectedDepartment,
    handleRemoveDepartment,
    handleAddDepartment,
    setIsShowEditDepartment,
    handleCreateInitiative,
    payloadData,
    handleDepartmentRemoval,
    fetchInitiativeById,
    initiativeId,
  } = props;

  const [validationError, setValidationError] = useState<string | null>(null);
  const [isReset, setIsReset] = useState(false);

  const validationSchema = () => Yup.object().shape({});

  const handleDepartmentSelection = async (department: any) => {
    setValidationError(null);

    const isAlreadySelected = selectedDepartment?.find(
      (dept: any) => dept.text === department.text,
    );

    if (isAlreadySelected) {
      if (handleDepartmentRemoval) {
        const canRemove = await handleDepartmentRemoval(department.id);
        if (canRemove) {
          handleRemoveDepartment(
            department.text,
            department.id,
            department.employeeId,
          );
        } else {
          setValidationError(
            `You can’t delete this department as it has cleared milestones.`,
          );
        }
      } else {
        handleRemoveDepartment(
          department.text,
          department.id,
          department.employeeId,
        );
      }
      return;
    }

    handleAddDepartment(department.text, department.id, department.employeeId);
  };

  return (
    <Dialog
      open={isShowEditDepartment}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={`company-dashboard-initiative-drawer-side-bar-department-popup `}
      onClose={(event, reason) => {
        if (reason === "backdropClick") {
          return;
        }
        setValidationError(null);
        setIsShowEditDepartment(false);
        onSearch("");
        setIsReset(true);
        setTimeout(() => {
          setIsReset(false);
        }, 100);
      }}
    >
      <DialogTitle id="alert-dialog-title">
        <div
          className="header-wrapper"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div className="header-wrapper-text">Participating Department(s)</div>
          <button
            style={{
              background: "transparent",
              border: "none",
              cursor: "pointer",
              padding: 0,
            }}
            onClick={() => {
              setValidationError(null);
              setIsShowEditDepartment(false);
              onSearch("");
              setIsReset(true);
              setTimeout(() => {
                setIsReset(false);
              }, 100);
            }}
          >
            <img
              alt="Close"
              src={CloseIcon}
              className="close-icon"
              style={{ cursor: "pointer" }}
            />
          </button>
        </div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {validationError && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginBottom: "16px",
                color: "#f37e7cff",
                fontSize: "13px",
                fontWeight: 500,
                fontFamily: '"Manrope", sans-serif',
              }}
            >
              {validationError}
            </div>
          )}
          <Formik
            initialValues={{}}
            validationSchema={validationSchema}
            validateOnChange={true}
            enableReinitialize={true}
            onSubmit={() => {
              handleCreateInitiative(setIsShowEditDepartment, {
                ...payloadData,
                departmentIds: selectedDepartment.map((dept: any) => dept.id),
              });
            }}
          >
            {() => (
              <Form>
                <div className="company-dashboard-initiative-drawer-side-bar-content-participating-edit">
                  <div className="company-dashboard-initiative-drawer-side-bar-content-participating-edit-search">
                    <SearchInputComponent
                      placeholder="Search Departments"
                      onSearch={onSearch}
                      isReset={isReset}
                      ref={null}
                    />
                  </div>
                  <OverlayScrollbarsComponent
                    options={{
                      overflow: { x: "scroll", y: "scroll" },
                      scrollbars: {
                        theme: "os-theme-dark",
                        autoHide: "scroll",
                        autoHideDelay: 400,
                      },
                    }}
                    className="company-dashboard-initiative-drawer-side-bar-content-participating-content  participating-content-scrollable"
                  >
                    {departments.map((department: any, index: number) => (
                      <button
                        type="button"
                        className={`company-dashboard-initiative-drawer-side-bar-content-participating-content-item ${
                          selectedDepartment?.find(
                            (dept: any) =>// NOSONAR
                             dept?.text === department?.text,
                          )
                            ? "selected"
                            : ""
                        }`}
                        key={index + 1}
                        style={{
                          backgroundColor: department.color || "#DDEAFF",
                          cursor: "pointer",
                          border: "none",
                          textAlign: "left",
                        }}
                        onClick={async () => {
                          await handleDepartmentSelection(department);
                        }}
                        onKeyDown={(event) => {
                          if (event.key === "Enter" || event.key === " ") {
                            event.preventDefault();
                            (event.currentTarget as HTMLButtonElement).click();
                          }
                        }}
                        onTouchStart={async () => {
                          await handleDepartmentSelection(department);
                        }}
                      >
                        <div className="company-dashboard-initiative-drawer-side-bar-content-participating-content-item-label">
                          {department?.text}{" "}
                        </div>{" "}
                        <div className="company-dashboard-initiative-drawer-side-bar-content-participating-content-item-img">
                          {selectedDepartment?.find(
                            (dept: any) =>// NOSONAR
                            dept?.text === department?.text,
                          ) ? (
                            <img
                              src={CloseIcon}
                              alt="close"
                              className="close-icon-selected"
                            />
                          ) : (
                            <span>+</span>
                          )}
                        </div>
                      </button>
                    ))}
                    {departments.length === 0 && (
                      <div
                        className="no-data-found"
                        style={{
                          textAlign: "center",
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          padding: "20px 0",
                        }}
                      >
                        Participating Department(s) Not Found
                      </div>
                    )}
                  </OverlayScrollbarsComponent>
                  <div className="company-dashboard-initiative-drawer-side-bar-content-participating-edit-action">
                    <button
                      className="company-dashboard-initiative-drawer-side-bar-content-participating-edit-action-cancel"
                      type="button"
                      onClick={() => {
                        setValidationError(null);
                        setIsShowEditDepartment(false);
                        onSearch("");
                        setIsReset(true);
                        fetchInitiativeById(initiativeId);
                        setTimeout(() => {
                          setIsReset(false);
                        }, 100);
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className="company-dashboard-initiative-drawer-side-bar-content-participating-edit-action-save"
                      type="submit"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default CompanyDashboardInitiativeDrawerSideBarDepartmentPopup;
